import { ArtifactsEditor } from "@/component/artifact-editor";
import { ArtifactPreview } from "@/component/artifact-preview";
import { atom } from "jotai";
import { store } from ".";
import { sidebarLayoutAtom, SidebarStatus } from "./sidebar";

export const setArtifactAtom = atom(null, (_, set, { code }: { code?: string }) => {
  const currentArtifact = store.get(artifactAtom);
  set(artifactAtom, {
    code: typeof code === 'undefined' ? currentArtifact.code : code,
  });
});

export const artifactAtom = atom({
  code: '',
})


export const setArtifactSidebarLayoutAtom = atom(null, (_, set, selectedTab?: string) => {
  set(sidebarLayoutAtom, () => ({
    selectedTab: selectedTab || 'preview',
    sidebarStatus: SidebarStatus.Open,
    enableFullScreenTrigger: true,
    tabs: [
      {
        id: 'code',
        title: 'code',
        visible: false,
        loading: false,
        content: <ArtifactsEditor />
      },
      {
        id: 'preview',
        title: 'preview',
        visible: false,
        loading: false,
        content: <ArtifactPreview />
      },
    ]
  }));
});
